import { render, staticRenderFns } from "./PopupAddToGroups.vue?vue&type=template&id=65acc444&scoped=true&"
import script from "./PopupAddToGroups.vue?vue&type=script&lang=js&"
export * from "./PopupAddToGroups.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddToGroups.vue?vue&type=style&index=0&id=65acc444&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65acc444",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})
